import IndividualForm from './IndividualForm'

export default IndividualForm
